import React, { PureComponent } from 'react';

import OneVisualLayout from '../../layouts/one-visual';
import HorizontalBarChart from "../../../../components/charts/horizontal-bar";
import styled from 'styled-components';

const getPercentage = value => (
  value > 0 ? `${(value * 100).toFixed(0)}%` : "0%"
);

const colors = [
  '#3A507B',
  '#445982',
  '#4E6288',
  '#586B8F',
  '#617395',
  '#6B7C9C',
  '#7585A3',
  '#9DA8BD'
];

const ChartContainer = styled.div`
  padding: 15px 20px 10px;
  font-family: 'Mukta Vaani';
  position: relative;

  > h3 {
    color: #EA4335;
    font-size: 16px;
    line-height: 16px;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 30px;
    font-weight: 700;
  }
`;

const ChartLabel = styled.p`
  font-size: 12px;
  line-height: 15px;
  color: #3A507B;
  font-weight: 600;
  text-align: center;
  margin-top: 15px;

  ${p => p.rotated && `
    transform: rotate(-90deg) translateX(30%);
    position: absolute;
    top: 50%;
    margin-top: 0;
  `}
`;

class ResultsAreInStep1 extends PureComponent {
  // Both the "X of N" text and the per-bucket bar values come from
  // the consolidated /teamgradings/overall/<round_id> response that
  // the container already fetched — no second API call from here.

  buildChartData(teams) {
    const inRange = (v, lo, hi) => v >= lo && v < hi;
    const buckets = [
      ['100%', t => Number(t.current_weighted_value) === 1],
      ['95%',  t => inRange(Number(t.current_weighted_value), 0.95, 1)],
      ['90%',  t => inRange(Number(t.current_weighted_value), 0.90, 0.95)],
      ['85%',  t => inRange(Number(t.current_weighted_value), 0.85, 0.90)],
      ['80%',  t => inRange(Number(t.current_weighted_value), 0.80, 0.85)],
      ['75%',  t => inRange(Number(t.current_weighted_value), 0.75, 0.80)],
      ['70%',  t => inRange(Number(t.current_weighted_value), 0.70, 0.75)],
      ['less than 70%', t => Number(t.current_weighted_value) < 0.70],
    ];
    return buckets.map(([name, fn]) => ({
      name,
      value: teams.filter(fn).length,
    }));
  }

  render() {
    const {
      activeRound,
      teamGradings = [],
      teamGradingsLength,
      overallStats,
      successfulTeamsCount,
    } = this.props;

    const stats = (overallStats && overallStats.current_weighted_value) || {};
    const averageTeamGrade = Number(stats.mean) || 0;
    const medianTeamGrade = Number(stats.median) || 0;
    const standardTeamGrade = Number(stats.standard_deviation) || 0;

    const chartData = this.buildChartData(teamGradings);

    return (
      <OneVisualLayout
        title={`RESULTS ARE IN! | ROUND ${activeRound} SCORE`}
        paragraph1={(
          <p><b>{successfulTeamsCount || 0}</b> out of <b>{teamGradingsLength}</b> teams hit their financial targets for the round. The average team score was {getPercentage(averageTeamGrade)}, the median was {getPercentage(medianTeamGrade)}, and the standard deviation was {getPercentage(standardTeamGrade)}.</p>
        )}
        visual={(
          <ChartContainer>
            <h3>Team Score Distribution</h3>
            <ChartLabel rotated={true}>no. of teams</ChartLabel>
            <HorizontalBarChart
              data={chartData}
              colors={colors}
              height={290}
              xAxisLine={false}
              hideYAxis={false}
              hideXAxis={true}
              xAxisTick={true}
              barSize={50}
              showBarLabel={true}
              showIntegerLabel={true}
            />
            <ChartLabel>Team Score</ChartLabel>
          </ChartContainer>
        )}
        visualProps={{
        }}
      />
    );
  }

}

export default ResultsAreInStep1;


// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/results-are-in/step1.js